import { useEffect, useState } from 'react'
import Spinner from '../Spinner/Spinner'
import Page from './Page'
import Alert from '../Alert/Alert'

const NewsLetters = () => {
	const [newsLetters, setNewsLetters] = useState([])
	const [loading, setLoading] = useState(false)

	const token = JSON.parse(localStorage.getItem('user'))

	useEffect(() => {
		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/newsletters')
			.then((res) => res.json())
			.then((data) => [setNewsLetters(data), setLoading(false)])
	}, [])

	const handleDelete = (id) => {
		fetch(`https://cp-node-api.herokuapp.com/api/newsletters/${id}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				token: `Bearer ${token.accessToken}`,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				const newNLs = newsLetters.filter((n) => n._id !== data._id)
				setNewsLetters(newNLs)
			})
	}

	return (
		<Page>
			{loading ? (
				<Spinner />
			) : (
				<>
					{newsLetters.length > 0 ? (
						<table className='table table-striped table-hover table-responsive w-50'>
							<thead>
								<tr>
									<th scope='col'>#</th>
									<th scope='col'>Email</th>
									<th scope='col'>Created At</th>
								</tr>
							</thead>
							<tbody>
								{newsLetters.map((newsLetter, i) => (
									<tr key={newsLetter._id}>
										<th scope='row'>{i + 1}</th>
										<td>
											<a
												href={`mailto:${newsLetter.email}`}
											>
												{newsLetter.email}
											</a>
										</td>
										<td>{newsLetter.createdAt}</td>
										<td>
											<button
												onClick={() =>
													handleDelete(newsLetter._id)
												}
												className='btn btn-danger'
											>
												Delete
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<div className='w-50'>
							<Alert msg='No newsletters found' />
						</div>
					)}
				</>
			)}
		</Page>
	)
}

export default NewsLetters
